import { render, staticRenderFns } from "./PracticeStart.vue?vue&type=template&id=48a1fb4c&scoped=true&"
import script from "./PracticeStart.vue?vue&type=script&lang=js&"
export * from "./PracticeStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1fb4c",
  null
  
)

export default component.exports